// extracted by mini-css-extract-plugin
export default {"container":"SN-z","topReviewHeading":"TN-z","criticalReview":"UN-z","favorableReview":"VN-z","vsSeparator":"WN-z"};